export enum PatientInviteReceiver {
  newPatient = 'newPatient',
  individual = 'individual',
  membersOfOneFamily = 'membersOfOneFamily',
  patientsWhoMeetCriteria = 'patientsWhoMeetCriteria',
}